export { default } from './ConfirmationModalCDS';
